import React, { Component } from 'react';

import { UTILITY_USER_ROLE_ADMIN } from 'common/utility/userRoles';

import branch from 'client/core/branch';
import withScreenId from 'client/helpers/withScreenId';
import withTransitionHook from 'client/helpers/withTransitionHook';
import allowedUtilityRoles from 'client/helpers/allowedUtilityRoles';
import withScrollToTop from 'client/helpers/withScrollToTop';
import { SCREEN_ID_UTILITY_PROFIT_ADMIN_ACCOUNTING_DASHBOARD } from 'client/constants/screenIds';

import UtilityDealerActions from 'client/actions/UtilityDealer';
import UtilityUserActions from 'client/actions/UtilityUser';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import UPAdminAccountingDashboard from 'client/components/UPAdminAccountingDashboard/UPAdminAccountingDashboard';

@withTransitionHook
@withScreenId(SCREEN_ID_UTILITY_PROFIT_ADMIN_ACCOUNTING_DASHBOARD)
@withScrollToTop
@branch({
  utilityDealers: ['utilityDealers', 'list'],
  utilitySalesReps: ['utilitySalesReps', 'list'],
})
@allowedUtilityRoles({
  roles: [UTILITY_USER_ROLE_ADMIN],
})
class UtilityProfitAdminAccountingDashboardPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Accounting Dashboard | Utility Profit',
  });

  static fetchData(state, inject) {
    return Promise.all([
      UtilityDealerActions.getList(inject),
      UtilityUserActions.getSalesRepList(inject),
    ]);
  }

  render() {
    const { utilityDealers, utilitySalesReps } = this.props;

    return (
      <SrPartnerPageV2
        navbarTitle="Utility Profit Admin"
        navbarImage="/images/utility-profit-logo.svg"
        backUrl="/utility-profit/admin"
        redirectToLastLocation={false}
        maxWidth="100%"
      >
        <UPAdminAccountingDashboard
          utilityDealers={utilityDealers}
          utilitySalesReps={utilitySalesReps}
        />
      </SrPartnerPageV2>
    );
  }
}

export default UtilityProfitAdminAccountingDashboardPage;
